<template lang="html">
  <div class="">
    <search-form @search="search" :ruleForm="ruleForm" />
    <cost-table ref="costTable" :ruleForm="ruleForm" />
  </div>
</template>

<script>
import searchForm from "./components/searchForm";
import costTable from "./components/costTable";
export default {
  data() {
    return {
      ruleForm: {
        costType: 1,
        createTime: [],
        totalMoney: {
          type: 0,
          start: "",
          end: ""
        }
      }
    };
  },
  computed: {},
  created() {},
  methods: {
    search() {
      this.$refs.costTable.getDataList(true);
    }
  },
  watch: {},
  components: {
    searchForm,
    costTable
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/personal/cost/index.vue